import React from 'react';

const toFiniteNumber=(value)=>{
  if (typeof value==='number') return Number.isFinite(value) ? value : 0;

  if (typeof value==='string') {
    const parsed=Number(value.replace(/[^0-9.-]/g,''));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  if (value && typeof value==='object') {
    return toFiniteNumber(
      value.amount ?? value.value ?? value.price ?? value.unit_price
    );
  }

  return 0;
};

const money=(value,currency='cad')=>(
  `${currency.toUpperCase()} ${toFiniteNumber(value).toLocaleString(undefined,{
    minimumFractionDigits:2,
    maximumFractionDigits:2
  })}`
);

const signedMoney=(value,currency='cad')=>{
  const amount=toFiniteNumber(value);
  const prefix=amount>0 ? '+' : amount<0 ? '-' : '';

  return `${prefix}${money(Math.abs(amount),currency)}`;
};

const quantityFor=(item)=>Math.max(1,toFiniteNumber(item?.quantity)||1);

const customizedUnitPriceFor=(item)=>toFiniteNumber(
  item?.unit_price ?? item?.price ?? item?.amount
);

const customizationTotalFor=(item)=>toFiniteNumber(
  item?.customization_total
    ?? item?.customization_price
    ?? item?.customization_adjustments_total
    ?? item?.option_adjustment
    ?? item?.customization_adjustment
);

export const baseUnitPriceFor=(item)=>{
  const explicitBasePrice=item?.base_price
    ?? item?.base_unit_price
    ?? item?.original_unit_price;

  if (explicitBasePrice !== undefined && explicitBasePrice !== null) {
    return toFiniteNumber(explicitBasePrice);
  }

  const quantity=quantityFor(item);
  const customizationTotal=customizationTotalFor(item);

  return Math.max(
    0,
    customizedUnitPriceFor(item)-(customizationTotal/quantity)
  );
};

const PriceRow=({label,value,accent=false,strong=false})=>(
  <div>
    <p className="text-[9px] font-black uppercase tracking-widest text-slate-400">
      {label}
    </p>
    <p className={`mt-1 font-black ${
      strong
        ? 'text-slate-900'
        : accent
          ? 'text-indigo-600'
          : 'text-slate-700'
    }`}>
      {value}
    </p>
  </div>
);

const OrderPriceBreakdown=({item,currency='cad'})=>{
  const quantity=quantityFor(item);
  const baseUnitPrice=baseUnitPriceFor(item);
  const customizationTotal=customizationTotalFor(item);
  const customizationUnitPrice=customizationTotal/quantity;
  const lineTotal=baseUnitPrice*quantity;

  return (
    <div className="mt-3 rounded-xl border border-indigo-100 bg-indigo-50/60 p-3">
      <p className="text-[9px] font-black uppercase tracking-widest text-indigo-500">
        Price breakdown
      </p>

      <div className="mt-3 grid gap-2 text-xs sm:grid-cols-3">
        <PriceRow
          label="Base unit price before customizations"
          value={money(baseUnitPrice,currency)}
        />
        <PriceRow
          label="Customization / unit"
          value={signedMoney(customizationUnitPrice,currency)}
          accent
        />
        <PriceRow
          label="Total for base units"
          value={`${quantity} × ${money(baseUnitPrice,currency)} = ${money(lineTotal,currency)}`}
          strong
        />
      </div>

      <div className="mt-3 flex items-center justify-between gap-3 border-t border-indigo-100 pt-3 text-xs">
        <span className="font-bold text-slate-600">
          Total customization price
        </span>
        <span className="font-black text-indigo-700">
          {signedMoney(customizationTotal,currency)}
        </span>
      </div>
    </div>
  );
};

export default OrderPriceBreakdown;